module.exports = __webpack_public_path__ + "img/KM600.6d39b8d1.png";